/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { CampaignUploadPathParams, CampaignUploadRequest, CampaignUploadResponse } from '../types/CampaignUpload'
import { buildFormData } from '../utils/form-data'

/**
 * POST /campaigns/:campaign/images
 * @see backend/nexus/modules/Campaign/Http/Controllers/CampaignController.php CampaignController::upload
 */
export async function campaignUpload(
	campaign: CampaignUploadPathParams['campaign'],
	data: CampaignUploadRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CampaignUploadResponse>> {
	return axiosInstance.post(`/campaigns/${campaign}/images`, buildFormData(data), {
		headers: { 'Content-Type': 'multipart/form-data' },
		...config,
	})
}
